// extracted by mini-css-extract-plugin
export default {"ActionButton":"authentication-module-faa27306b668e2af95a5"};